import { use } from 'react';
import { WebsiteStoreContext } from '../client/StoreProvider';
import type { WebsiteAppContextValue } from '../appContext';

export function useWebsiteAppContext(): WebsiteAppContextValue {
  const value = use(WebsiteStoreContext);
  if (!value) throw new Error('useWebsiteAppContext must be used inside <StoreProvider>');
  return value;
}
